// JavaScript Document
//components/configuration/PowerPicker.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
//const utils = require('../configuration/DaysettingUtils');

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 130,
  },
  valueField: {
	  marginLeft: theme.spacing(1),
	  marginRight: theme.spacing(1),
	  width: 50
  },
  gridder: {
	  padding: theme.spacing(3)
  }
}));

export default function SettingPicker(props) {
  	const classes = useStyles();
  	const {time, value, onChange, type} = props;
	const [myTime, setMyTime] = React.useState('00:00:00');
	const [myValue, setMyValue] = React.useState(99);
	//handle user changes to value
  	const handleValueChange = (e) => {
		let val = parseInt(e.target.value)
		if(val > 99){
			val = 99;
		} else if (val < 0 || isNaN(val)){
			val = 0;
		}
		setMyValue(val);
  	};
	//handle user changes to time
  	const handleTimeChange = (e) => {
	  	setMyTime(e.target.value);
  	};
	//handle update to parent
  	const handleUpdate = () => {
	  	if(onChange){
			onChange(myTime, myValue);
		}
  	};
  	React.useEffect(() => {
		//setMyTime(time);
		//setMyValue(value);
		if(time){
			setMyTime(time);
		}
		if(value !== null && value !== undefined && !isNaN(parseInt(value))){
			setMyValue(value);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);

  return (
	  <Grid container justifyContent="space-around" className={classes.gridder}>
    		<TextField
        		id="value"
        		label={type}
        		type="number"
	  			value={myValue.toString()}
        		className={classes.valueField}
	  			onChange={handleValueChange}
	  			autoFocus={true}
	  			required={true}
        		InputLabelProps={{
	  				shrink: true,
        		}}
        		inputProps={{
	  				step: 5, 
	  				min: 0,
	  				max: 99
        		}}
      		/>
	  		<TextField
        		id="time"
        		label="Time"
        		type="time"
	  			onChange={handleTimeChange}
	  			value={myTime}
	  			required={true}
        		className={classes.textField}
        		InputLabelProps={{
	  				shrink: true,
        		}}
        		inputProps={{
	  				step: 300, // 5 min
        		}}
      		/>
	  		<Button variant="contained" color="primary" onClick={handleUpdate}>
  				Add
	  		</Button>
	  </Grid>
  );
}
